module.exports = __webpack_public_path__ + "static/media/icon-stp.6ffc2dc5.svg";